/**
 * 전역 스타일 정의
 * 폰트, 리셋 CSS 등 애플리케이션 전체에 적용되는 스타일을 정의합니다.
 */

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* 폰트 정의 */
  @font-face {
    font-family: 'koPubWorld DotumM';
    src: url('/font/KoPubWorldDotumMedium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'koPubWorld DotumB';
    src: url('/font/KoPubWorldDotumBold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'MapoPeacefull';
    src: url('/font/MapoPeacefull.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Nanum Gothic Bold';
    src: url('/font/NanumGothicBold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Nanum Square Bold';
    src: url('/font/NanumSquareB.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  /* 기본 스타일 리셋 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    /* 반응형 기본 설정 */
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;

    /* 부드러운 스크롤 */
    scroll-behavior: smooth;
  }

  body {
    font-family: 'koPubWorld DotumM', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* 최소 너비 설정 */
    min-width: 320px;

    /* 기본 폰트 크기 (반응형 조정) */
    font-size: 16px;

    /* 기본 라인 높이 */
    line-height: 1.6;

    /* 기본 색상 */
    color: #333333;
    background-color: #ffffff;

    /* 모바일에서 가로 스크롤 방지 */
    overflow-x: hidden;
  }

  /* 이미지 반응형 처리 */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* 버튼 기본 스타일 초기화 */
  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    background: none;
    -webkit-tap-highlight-color: transparent;
  }

  /* 링크 기본 스타일 */
  a {
    text-decoration: none;
    color: inherit;
    -webkit-tap-highlight-color: transparent;
  }

  /* 리스트 스타일 제거 */
  ul, ol {
    list-style: none;
  }

  /* 인풋, 텍스트 영역 기본 스타일 */
  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  /* 테이블 기본 스타일 */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* 반응형 타이포그래피 */
  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    line-height: 1.2;
  }

  /* 접근성: 스크린 리더 전용 텍스트 */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  /* 반응형 컨테이너 */
  .container {
    width: 100%;
    max-width: 1020px;
    margin: 0 auto;
    padding: 0 20px;

    @media (max-width: 767px) {
      padding: 0 16px;
    }
  }

  /* 모바일에서 터치 액션 최적화 */
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-touch-callout: none;
  }

  /* 스크롤바 스타일링 (선택사항) */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f4f4f4;
  }

  ::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #b0b0b0;
  }
`;

export default GlobalStyle;
